import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ProgrammingUtilsService as Utils } from '../services/utils.service';
import { Event } from '../interfaces/event.interface';

export abstract class BaseRoutingComponent implements OnInit {

  protected abstract router: Router;
  protected abstract store: Store<any>

  constructor(
  ) { }

  ngOnInit() { }

  private mr: ActivatedRoute;

  get moduleRoot(): ActivatedRoute {
    this.mr = this.mr || this.buildModuleRoot();
    return this.mr;
  }

  private buildModuleRoot = (): ActivatedRoute => {
    return (function getKids(active: ActivatedRoute): ActivatedRoute[] {
      return [active].concat(...(active.children || [])
        .map(c => getKids(c)))
    })(this.router.routerState.root).find((active: ActivatedRoute) => {
      return (typeof active.component === 'function') ?
        active.component.name === "ProgrammingComponent" : false;
    });
  }

  protected goHome() {
    this.router.navigate(['when-then/start'], { relativeTo: this.moduleRoot });
  }


  protected goToEvent() {
    let event = Utils.snapshot<Event>(this.store.select(s => s.sharedProgramming.trigger.event));
    if (!!event) {
      this.router.navigate(['when-then', 'device', event.deviceId, 'event', event.eventId, 'edit'], { relativeTo: this.moduleRoot });
    }
  }

  // HACK should probably use route data for this
  protected isForTrigger(route: ActivatedRoute): boolean {
    let istrigger = true;
    if (route) {
      let pathFromRoot = Utils.getPathFromRoot(route);
      // console.log('url string', pathFromRoot);
      istrigger = (pathFromRoot.indexOf('trigger') > -1);
    }

    // console.log('is for trigger: ', istrigger);
    return istrigger;
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/common/base-routing/base-routing.component.ts